import { render, staticRenderFns } from "./action-table-column.vue?vue&type=template&id=4898dd81"
import script from "./action-table-column.vue?vue&type=script&lang=ts"
export * from "./action-table-column.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports